export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8687.cf229b05.jpg";